import Explore from '../containers/explore';
import ClientAdminTiles from '../containers/clientAdminTiles';
import TileCarousel from '../containers/tileCarousel';
import ActivityBoard from '../containers/activityBoard';
import TileSingleView from '../containers/tileSingleView';
import Changelog from '../containers/changelog';
import ChangelogReleaseShow from '../containers/changelog/ChangelogReleaseShow';

export default {
  '/client_admin/changelog/:id': ChangelogReleaseShow,
  '/client_admin/changelog': Changelog,
  '/explore': Explore,
  '/explore/audiences/:audience': Explore,
  '/explore/tile/:id': TileSingleView,
  '/client_admin/tiles': ClientAdminTiles,
  '/tiles': TileCarousel,
  '/tile/:id': TileSingleView,
  '/board/:public_slug/tile/:id': TileSingleView,
  '/ard/:public_slug/tiles': TileCarousel,
  '/board/:public_slug/tiles': TileCarousel,
  '/board/:public_slug': ActivityBoard,
  '/board/:public_slug/:highlight_slug': ActivityBoard,
  '/ard/:public_slug/activity': ActivityBoard,
  '/acts': ActivityBoard,
};
